import { render, staticRenderFns } from "./CathayPropertyHurtInsurance.vue?vue&type=template&id=589761b0"
import script from "./CathayPropertyHurtInsurance.vue?vue&type=script&lang=js"
export * from "./CathayPropertyHurtInsurance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports